import { useState } from 'react';
import { useApp } from 'context/AppContext';
import { Goods, Loader } from 'components';
import { Button } from 'styles/AppStyles';
import AppService from 'services/app.service';
import { Container, SubTitle } from './Styles';

import { storeUser } from 'utils/auth';

const VipBonus = ({ data }) => {
  const {
    closeModal,
    setVipBonusTime,
    setUserData,
    setVipBonusClaimed,
    state: { user },
  } = useApp();
  const { gLt, vae } = data;
  const [isLoading, setIsLoading] = useState(false);

  const handleClaim = () => {
    if (isLoading) return;
    setIsLoading(true);

    AppService.claimDynamicBonus({ vae })
      .then(({ sts, dBCn, rGs }) => {
        if (sts === 's') {
          if (dBCn) setVipBonusTime(dBCn);

          const coinsReward = rGs?.find(item => item.gTe === 'C');
          if (coinsReward && user) {
            const newCoins = (user.cBe || 0) + coinsReward.quy;
            const updatedUser = { ...user, cBe: newCoins };
            setUserData(updatedUser);
            storeUser(updatedUser);
          }
          setVipBonusClaimed(true);
        } else {
          alert('Failed to claim bonus');
        }
      })
      .catch(() => {
        console.error('An error occurred while claiming the bonus');
      })
      .finally(() => {
        setIsLoading(false);
        closeModal();
      });
  };

  return (
    <Container>
      <Goods goods={gLt} withStyle />
      <SubTitle>The bonus was claimed to your account</SubTitle>
      <Button $isModal onClick={handleClaim}>
        ROLL ON!
        {isLoading && <Loader size={16} width={3} />}
      </Button>
    </Container>
  );
};

export default VipBonus;
